import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import toast from "react-hot-toast";
import api from "../../../config/URL";
import { useNavigate } from "react-router-dom";

function Withdraw({ handleLogout }) {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleWithdraw = async () => {
    setLoadIndicator(true);
    try {
      const response = await api.post(`affiliate/affiliate-user/withdrawn`);
      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message);
        handleClose();
        handleLogout();
        navigate("/");
      } else if (response.status === 422) {
        toast.error(response.data.message);
      }
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data?.message || "Something went wrong.");
    } finally {
      setLoadIndicator(false);
    }
  };

  return (
    <div>
      <button type="button" className="btn btn-light btn-sm">
        <span onClick={handleShow}>Delete My Account</span>
      </button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete My Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete your account?</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-light btn-sm" onClick={handleClose}>
            Close
          </button>
          <button
            className="btn btn-sm btn-button"
            onClick={handleWithdraw}
            disabled={loadIndicator}
          >
            {loadIndicator && (
              <span
                className="spinner-border spinner-border-sm me-2"
                aria-hidden="true"
              ></span>
            )}
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Withdraw;
